import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  className?: string;
  fullWidth?: boolean;
  showIcon?: boolean;
  scrollToPurchase?: boolean;
}
export function CTAButton({
  text,
  className = '',
  fullWidth = false,
  showIcon = false,
  scrollToPurchase = false
}: CTAButtonProps) {
  const checkoutUrl = 'https://checkout16.recursospro.shop/cart/45212460810284:1';
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (scrollToPurchase) {
      e.preventDefault();
      const purchaseSection = document.getElementById('purchase-section');
      if (purchaseSection) {
        purchaseSection.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  };
  return <a href={checkoutUrl} onClick={handleClick} className={`
        inline-flex items-center justify-center
        bg-blue-600 hover:bg-blue-700 text-white font-semibold
        py-4 px-8 rounded-xl shadow-md hover:shadow-lg
        transition-all duration-200
        ${fullWidth ? 'w-full' : 'w-auto'}
        ${className}
      `} data-id="element-1">
      {text}
      {showIcon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-2" />}
    </a>;
}